import {Flex} from "antd";
import React from "react";
import {
    FinancePartnerDetailsResponse,
    OpportunityInfoResponse,
} from "../../../../../services/oneButtonServices/opportunityValidationService";

type QuickLink = {
    name: string;
    url: string;
};

const salesforceBaseUrl = import.meta.env.VITE_SALESFORCE_PRODUCTION_BASE_URL;
const webGenesisBaseUrl = import.meta.env.VITE_WEBGENESIS_BASE_URL;

interface QuickLinksProps {
    opportunity: OpportunityInfoResponse;
    financePartner: FinancePartnerDetailsResponse;
}

export const QuickLinks: React.FC<QuickLinksProps> = ({opportunity, financePartner}) => {

    const oppSfId = opportunity.sfdc.sfdcOpportunityId;

    const links: QuickLink[] = [
        {
            name: 'Salesforce Opportunity',
            url: `${salesforceBaseUrl}/lightning/r/Opportunity/${oppSfId}/view`,
        },
        {
            name: 'Salesforce Opportunity - Box',
            url: `${salesforceBaseUrl}/lightning/r/Opportunity/${oppSfId}/view`,
        },
        {
            name: 'Salesforce Opportunity - Direct Lead',
            url: `${salesforceBaseUrl}/lightning/r/Direct_Lead__c/${opportunity.sfdc.sfdcDirectLeadId}/view`,
        },
        {
            name: 'Finance Partner - Lead ID',
            url: `https://sunnova.my.site.com/partnerconnect/s/lead/${financePartner.financePartnerLeadId}`,
        },
        {
            name: 'DCED Flood Map Zone',
            url: 'https://dced.maps.arcgis.com/apps/webappviewer/index.html',
        },
        {
            name: 'FEMA',
            url: 'https://msc.fema.gov/portal/home',
        },
        {
            name: 'SiteXPro',
            url: 'https://sitexpro.com/',
        },
        {
            name: 'SiteCapture',
            url: 'https://solar.sitecapture.com/app/#/dashboard',
        },
        {
            name: 'Genesis',
            url: `${webGenesisBaseUrl}/home?sfoi=${oppSfId}`,
        },
        {
            name: 'Dropbox link to Salesrep folder',
            url: 'https://www.dropbox.com/work',
        },
        {
            name: 'Google Map',
            url: `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${opportunity.sfdc.sfdcLatitude},${opportunity.sfdc.sfdcLongitude}`,
        },
    ];

    return (
        <Flex wrap>
            {links.map((link) =>
                <a
                    style={{padding: '10px', width: '25%'}}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {link.name}
                </a>
            )}
        </Flex>
    );
};